export function pluralize(
  counter: number,
  word = 'patient',
  suffix = 's',
): string {
  return `${word}${counter !== 1 ? suffix : ''}`;
}
